import Loadable from "react-loadable";
import PublicLayout from "components/layout/publicLayout";
import Loader from "components/shared/loader/loader";

const Login = Loadable({
  loader: () => import("../../container/login"),
  loading() {
    return <Loader />;
  }
});

const ForgotPassword = Loadable({
  loader: () => import("../../container/forgotPassword"),
  loading() {
    return <Loader />;
  }
});

const ResetPassword = Loadable({
  loader: () => import("../../container/resetPassword"),
  loading() {
    return <Loader />;
  }
});

const SetPassword = Loadable({
  loader: () => import("../../container/setPassword"),
  loading() {
    return <Loader />;
  }
});

export const PublicRoutes = [
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      {
        path: "/auth",
        element: <Login />
      },
      {
        path: "/auth/forgot-password",
        element: <ForgotPassword />
      },
      {
        path: "/auth/reset-password",
        element: <ResetPassword />
      },
      {
        path: "/auth/set-password",
        element: <SetPassword />
      }
    ]
  }
];
